/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { agentSchedulesCreateAgentSchedule } from "../../funcs/agentSchedulesCreateAgentSchedule.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.CreateAgentScheduleRequest$inboundSchema,
};

export const tool$agentSchedulesCreateAgentSchedule: ToolDefinition<
  typeof args
> = {
  name: "agent-schedules-create-agent-schedule",
  description: `Create an agent schedule

Creates a Temporal-backed one-time, interval, or cron schedule that starts normal saved agent runs.`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await agentSchedulesCreateAgentSchedule(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
